export default "__VITE_ASSET__Ti1LbfLY__"